<style lang="scss" scoped>
  @import '../../../sass/_variables';

  .integration-gmail {
    position: relative;

    .google-button {
      position: absolute;
      top: -17px;
      right: 15px;
    }

    .table {
      tr:first-child {
        td {
          border: 0;
        }
      }

      .empty {
        background: $white;

        td {
          color: $gray-light;
          font-size: 0.875rem;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: -0.17px;
          padding: 2px 0 1px;

          .small-text {
            font-size: 0.6875rem;
          }
        }
      }
    }
  }
</style>

<template>
  <div class="integration-gmail col-6">
    <div class="form-group">
      <label>{{ __('Integração Gmail') }}</label>
      <table class="table mt-10px">
        <tbody v-if="tokens === null">
          <tr class="empty">
            <td class="pt-10px">
              <i class="fa fa-circle-o-notch fa-spin" /><span class="ml-2">{{ __('Carregando...') }}</span>
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="tokens.length">
          <tr
            :key="token.id"
            v-for="(token, index) in tokens"
          >
            <td class="d-flex align-items-center">
              <span class="mr-3">{{ token.metadata.email }}</span><a
                class="ml-auto"
                href="#"
                @click.prevent="destroy(token, index)"
                v-b-tooltip.bottomleft="'Remover acesso'"
              >
                <IconTrash
                  :size="18"
                  v-if="! token.busy"
                /></a>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr class="empty">
            <td><span class="none">{{ __('Nenhum e-mail cadastrado') }}</span><br><small class="small-text">{{ __('Clique em "Fazer login com o Google" para autorizar o Bulldesk') }}.</small></td>
          </tr>
        </tbody>
      </table>
    </div><span class="google-button">
      <UserGoogleIntegrationButton /></span>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    auth: {
      type: String,
      required: true,
    },

    user: {
      type: String,
      required: true,
    },
  },

  computed: {
    can () {
      return this.auth === this.user;
    },
  },

  data () {
    return {
      tokens: null,
    };
  },

  created () {
    this.fetch();
  },

  methods: {
    redirect () {
      window.location = '/integration/google';
    },

    fetch () {
      this.$http.get('/user/token/google')
        .then(({ data }) => {
          this.tokens = data.map((token) => ({ ...token, busy: false }));
        });
    },

    destroy (token, index) {
      if (token.busy) {
        return;
      }

      token.busy = true;

      this.$http.delete(`/user/token/${token.id}`)
        .then(({ data }) => this.tokens.splice(index, 1));
    },
  },
};
</script>
